import DriveDetails from './DriveDetails';

export default DriveDetails;



// WEBPACK FOOTER //
// ./src/views/DriveDetails/index.js